
import { axios } from '@/services/axios';

export const getUserAcc = async (id) => {
    const res = await axios.get(`/User/${id}`);
    return res.data;
};